import { getNotClassList } from "./service";

const state = () => ({
  addClass: false, // 添加课节按钮
  total: 0, // 添加课节按钮
  classList: []
});

const mutations = {
  setAddClass(state, payload) {
    state.addClass = payload
  },
  setTotal(state, payload) {
    state.total = payload
  },
  setClassList(state, payload) {
    state.classList = payload
  }
};

const actions = {
  getNotClassList: (context, params) => {
    getNotClassList(params).then(res => {
      context.commit("setTotal", res?.total || 0)
      context.commit("setClassList", res?.list || [])
    })
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
